import * as R from "ramda";
import { ActionContext, Module } from "vuex";
import { IServerGenericResponse } from "../common/common-models";
import { ClubData } from "./club-data";
import { IClub } from "./club-models";
import { CLUB_STORE_CONST } from "../store/store-constants";
import type { IRootState } from "../store/root-state";
// import { getClubData } from "../common/services/service-registry";
import { getClubData } from "../common/services/service-registry";

export interface IClubDropDown {
  clubs: IClub[];
  clubSelected: IClub;
  clubsLoading: boolean;
}
export interface IClubStoreState {
  clubDropDown: IClubDropDown;
}

const mutations = {
  [CLUB_STORE_CONST.CLUB_STORE_MUTATIONS_SET_CLUBS](
    state: IClubStoreState,
    clubs: IClub[]
  ) {
    state.clubDropDown.clubs = R.clone(clubs);
  },
  [CLUB_STORE_CONST.CLUB_STORE_MUTATIONS_SET_CLUBS_LOADING](
    state: IClubStoreState,
    isLoading: boolean
  ) {
    state.clubDropDown.clubsLoading = isLoading;
  },
};

const actions = {
  [CLUB_STORE_CONST.CLUB_STORE_ACTIONS_GET_COMP_ORGS](
    context: ActionContext<IClubStoreState, IRootState>,
    payload: {
      public: boolean;
      defaultValueText: string;
      orgId: number;
    }
  ) {
    const clubData = getClubData();

    context.commit(
      CLUB_STORE_CONST.CLUB_STORE_MUTATIONS_SET_CLUBS_LOADING,
      true
    );
    const promData = payload.public
      ? clubData.getCompOrgsPublic()
      : clubData.getCompOrgs(payload.orgId);

    return promData
      .then((response: IServerGenericResponse) => {
        if (response.errNo > 0) {
          return;
        }
        let clubs: IClub[] = response.data as IClub[];
        clubs = clubs.sort((a: IClub, b: IClub) => {
          return a.club.localeCompare(b.club);
        });
        clubs.unshift({
          club: payload.defaultValueText
            ? payload.defaultValueText
            : "Select Organiser...",
          clubid: 0,
          id: 0,
        });
        context.commit(
          CLUB_STORE_CONST.CLUB_STORE_MUTATIONS_SET_CLUBS,
          response.data
        );
        context.commit(
          CLUB_STORE_CONST.CLUB_STORE_MUTATIONS_SET_CLUBS_LOADING,
          false
        );
        return;
      })
      .catch((_error: any) => {
        context.commit(CLUB_STORE_CONST.CLUB_STORE_MUTATIONS_SET_CLUBS, []);
        context.commit(
          CLUB_STORE_CONST.CLUB_STORE_MUTATIONS_SET_CLUBS_LOADING,
          false
        );
        return;
      });
  },
};

/**
 * Default state factory for club store
 * This replaces the inline state definition and ensures pure state initialization
 */
function getDefaultClubState(): IClubStoreState {
  return {
    clubDropDown: {
      clubs: [],
      clubsLoading: false,
      clubSelected: {} as IClub,
    },
  };
}

/**
 * Create club store module with dependency injection
 */
export function createClubStore(
  serviceContainer: any
): Module<IClubStoreState, IRootState> {
  return {
    namespaced: true,
    state: getDefaultClubState(),
    mutations,
    actions,
  };
}

// Legacy export for backward compatibility (will be removed after full migration)
export const clubStore: Module<IClubStoreState, IRootState> = {
  namespaced: true,
  state: getDefaultClubState(),
  mutations,
  actions,
};
